<template>
    <div class="item" :class="{'red': order.is_debt, 'gray': isNotDone}" @click="show">
        <div class="info">
            <div class="title">
                {{ alias || road }}
            </div>
            <div class="content">
                <div class="now" :class="colorClass">
                    <img v-show="isReserve || (order.status === 'done')" src="@/assets/img/tick.svg">
                    {{ order.status_text }}
                </div>
            </div>
            <div class="date">
                {{ date }}
            </div>
        </div>
        <div class="status">
            <div class="separation" v-show="order.is_debt || isDone || isMissing || isDispatching"/>
            <div v-if="order.is_debt" @click.stop="onPay">
                <div class="subtitle">
                    $ {{ price }}
                </div>
                <div class="button">
                    前往付款
                </div>
            </div>
            <div v-else-if="isDone" @click.stop="copyOrder">
                <div class="subtitle">
                    再訂一次
                </div>
                <div class="button">
                    $ {{ price }}
                </div>
            </div>
            <div v-else-if="isMissing" @click.stop="restartOrder(order.id)">
                <div class="subtitle">
                    <img src="@/assets/img/refresh.png">
                </div>
                <div class="button">
                    重新配對
                </div>
            </div>
            <div v-else-if="isDispatching" @click.stop="showTip = true">
                <div class="subtitle">
                    <img src="@/assets/img/time2.png">
                </div>
                <div class="button">
                    加速配對
                </div>
            </div>
            <div v-else-if="isWait">
                <div class="subtitle">
                    目前累積費用
                </div>
                <div class="button">
                    $ {{ price }}
                </div>
            </div>
            <div v-else-if="isReserve">
                <div class="subtitle">
                    開始執行日期
                </div>
                <div class="button">
                    {{ reserveDate }}
                </div>
            </div>
            <div v-else>
                <div class="subtitle">
                    預計送達時間
                </div>
                <div class="button" v-if="minutes > 0">
                    {{ minutes }} 分鐘
                </div>
                <div class="button" v-else>
                    即將到達
                </div>
            </div>
        </div>
        <div class="new-message" @click.stop="goToMessages" v-if="count">
            新訊息！
            <div class="count">{{ count }}</div>
        </div>
        <set-tip v-if="showTip" @onCancel="showTip = false" @onDone="setTip" :default-tip="order.prices.tip"/>
        <tip-modal ref="tipModal"/>
        <tip-up-modal ref="tipUpModal"/>
    </div>
</template>

<script>
    import moment from 'moment';
    import SetTip from '../AddTip';
    import TipUpModal from '../../modal/TipUpModal';
    import TipReduceModal from '../../modal/TipReduceModal';
    import { mapActions, mapGetters } from 'vuex';

    export default {
        name: 'ListItem',
        components: {
            'set-tip': SetTip,
            'tip-modal': TipReduceModal,
            'tip-up-modal': TipUpModal,
        },
        props: {
            order: {
                required: true
            },
            isHistory: {
                default: false,
            }
        },
        data() {
            return {
                showTip: false,
                now: null,
            }
        },
        computed: {
            isNotDone() {
                return this.isHistory && this.order.status !== 'done' && !this.order.is_debt;
            },
            reserveDate() {
                return moment(this.order.reserved_at).format('MM月DD日');
            },
            isDone() {
                return ['done', 'cancel', 'revoke'].indexOf(this.order.status) >= 0;
            },
            isReserve() {
                return this.order.status_text === '預約成功';
            },
            isWait() {
                return this.order.status_text === '目前排隊中';
            },
            isDispatching() {
                return ['dispatching', 'sending'].indexOf(this.order.status) >= 0;
            },
            isMissing() {
                return this.order.status === 'missing'
            },
            isProcessing() {
                return this.order.status === 'processing';
            },
            count() {
                let message = this.unreadMessages.find(message => message.messageable_id == this.order.id);
                if (!message) return 0;

                return message.count;
            },
            price() {
                return Math.max(parseInt(this.order.prices.base || 0) +
                    parseInt(this.order.prices.distance || 0) +
                    parseInt(this.order.prices.multiple || 0) +
                    parseInt(this.order.prices.tip || 0) -
                    parseInt(this.order.prices.discount || 0) +
                    parseInt(this.order.prices.wait || 0) +
                    parseInt(this.order.prices.fee || 0) +
                    parseInt(this.order.prices.behalf || 0), 0)
            },
            minutes() {
                return moment(this.order.estimated_time).diff(this.now, 'minutes');
            },
            alias() {
                return this.order.locations[0].alias;
            },
            road() {
                return this.order.locations[0].road;
            },
            colorClass() {
                if (this.order.is_debt) {
                    return {red: true};
                }

                return {
                    'green': this.isProcessing || this.isDone,
                    'blue': this.isDispatching,
                    'red': false,
                };
            },
            date() {
                let date = moment(this.order.reserved_at || this.order.sent_at);
                let now = moment();

                if (now.format('YYYY') === date.format('YYYY')) {
                    return date.format('MM/DD HH:mm');
                }

                return date.format('YYYY/MM/DD HH:mm')
            },
            ...mapGetters(['unreadMessages'])
        },
        methods: {
            goToMessages() {
                this.$router.push({
                    name: 'message',
                    params: {
                        id: this.order.id
                    }
                });
            },
            show() {
                if (this.order.status === 'processing' ||
                    this.order.status === 'dispatching' ||
                    this.order.status === 'appointing' ||
                    this.order.status === 'missing' ||
                    this.order.status === 'sending') {
                    this.$router.push({
                        name: 'timeline',
                        params: {
                            id: this.order.id,
                        }
                    })
                } else {
                    this.$router.push({
                        name: 'order',
                        params: {
                            id: this.order.id,
                        }
                    })
                }
            },
            copyOrder() {
                this.copyBuyOrder(this.order).then(page => {
                    this.$router.push({
                        name: page,
                    })
                });
            },
            onPay() {
                window.open(`/api/payments/${this.order.id}/credit`, '_new');
            },
            setTip(tip) {
                this.showTip = false;

                if (tip <= this.order.prices.tip) {
                    this.$refs.tipModal.show();
                    return;
                }

                this.$refs.tipUpModal.show(tip, this.order.id);
            },
            ...mapActions(['putOrder', 'restartOrder', 'copyBuyOrder'])
        },
        created() {
            this.now = moment();
            this.timeout = setInterval(() => {
                this.now = moment();
            }, 60 * 1000);
        },
        beforeDestroy() {
            clearInterval(this.timeout);
        }
    };
</script>

<style lang="scss" scoped>
    .item {
        position: relative;
        border-radius: 6px;
        background-color: #FFFFFF;
        box-shadow: 0 0 3px 0 rgba(51,153,51,0.35);
        margin: 10px;
        padding: 15px 15px 10px 15px;
        display: flex;
        justify-content: space-between;

        &.gray {
            .info {
                .title {
                    color: #9b9b9b !important;
                }

                .content {
                    .now {
                        color: #9b9b9b !important;
                    }
                }
            }

            .status {
                .button {
                    color: #9b9b9b !important;
                }
            }
        }

        .separation {
            position: absolute;
            width: 1px;
            background-color: rgba(51,153,51,0.15);
            top: -15px;
            bottom: -10px;
            right: 95px;
        }

        &.red {
            background-color: #FFFFFF;
            box-shadow: 0 0 3px 0 #D0021B;

            .separation {
                background-color: #d0021b47;
            }
        }

        .info {
            text-align: left;

            .title {
                color: #000000;
                font-family: "PingFang TC";
                font-size: 14px;
                line-height: 20px;
            }

            .date {
                margin-top: 5px;
                color: #9B9B9B;
                font-size: 12px;
                letter-spacing: 0;
                line-height: 17px;
            }

            .content {
                margin-top: 10px;
                color: #787878;
                font-family: "PingFang TC";
                font-size: 12px;
                font-weight: 500;
                line-height: 17px;
                display: flex;

                .place {
                    margin-left: 20px;
                }

                .now {
                    display: flex;
                    align-items: center;

                    img {
                        margin-right: 2px;
                    }

                    &.green {
                        color: #339933;
                    }

                    &.blue {
                        color: #4A90E2;
                    }

                    &.red {
                        color: #F44336;
                    }
                }
            }
        }

        .status {
            width: 80px;
            display: flex;
            align-items: center;
            padding-left: 15px;
            position: relative;

            div {
                margin: auto;
            }

            .subtitle {
                color: #9B9B9B;
                font-family: "PingFang TC";
                font-size: 14px;
                font-weight: 500;
                line-height: 17px;
                height: 17px;
                display: inline;
                white-space: nowrap;

                img {
                    height: 22px;
                    width: 22px;
                }
            }

            .button {
                margin-top: 5px;
                color: #000000;
                font-family: "PingFang TC";
                font-size: 18px;
                line-height: 25px;
            }
        }

        .new-message {
            position: absolute;
            border-radius: 10px;
            background-color: #F44336;
            color: #FFFFFF;
            height: 20px;
            padding: 1px 5px 1px 20px;
            font-size: 12px;
            font-weight: 600;
            line-height: 18px;
            text-align: center;
            top: -8px;
            right: 0;
            cursor: pointer;
            user-select: none;

            .count {
                width: 24px;
                height: 24px;
                background-color: #F44336;
                content: '';
                position: absolute;
                top: -2px;
                left: -8px;
                border: #FFFFFF 1px solid;
                border-radius: 20px;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }
    }
</style>
